import React, { useEffect, useState } from "react";
import { JSONTree } from "react-json-tree";
import RestHelper from "./helpers/RestHelper";
import _ from "lodash";

export default function Admin(props) {
  const { type } = props;

  const [username, setUserName] = useState();
  const [users, setUsers] = useState();

  const check = () => {
    RestHelper.fetchAuthenticated({
      url: "/admin/users/findByUserName",
      body: {
        username,
      },
      cb: setUsers,
    });
  };
  const togglePartner = (username, isPartner) => {
    RestHelper.fetchAuthenticated({
      url: "/admin/users/setPartner",
      body: {
        username,
        isPartner,
      },
      cb: () => {
        check();
      },
    });
  };

  return (
    <div style={{ padding: 8 }}>
      <input onChange={(e) => setUserName(e.target.value)} />
      <button onClick={check}>Search</button>
      <JSONTree data={users} />
      {_.map(users?.users, (user) => (
        <div key={`${user.username}`}>
          {user.username}{" "}
          <input
            type="checkbox"
            checked={user.isPartner}
            onClick={() => togglePartner(user.username, !user.isPartner)}
          ></input>
        </div>
      ))}
    </div>
  );
}
